import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty } from 'lodash';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { withStyles } from "@mui/styles";

const styles = (/* theme */) => ({
  fullWidth: {
    width: '100%'
  },
  spread: {
    justifyContent: 'space-evenly'
  },
  MuiInputLabel: {
    fontSize: 12
  }
});

class DeviceTypes extends React.Component {

  handleChange = evt => {
    const { value, onChange, deviceTypes } = this.props;
    let copy = value.slice();
    const selected = evt.target.value;
    const existing = value.find(v => v.name === selected);

    if (!isEmpty(existing)) {
      copy = copy.filter(c => c.name !== selected);
    } else {
      copy.push(deviceTypes.find(d => d.name === selected));
    }

    const data = {
      target: {
        name: 'DeviceTypes',
        value: copy
      }
    };
    onChange(data);
  };

  getCheckbox = (checked, value) => {
    const isChecked = checked || false;
    return (
      <Checkbox
        checked={isChecked}
        color="primary"
        onChange={this.handleChange}
        value={value}
      />
    )
  };

  render() {
    const { classes, value, disabled } = this.props;
    const names = value.map(v => v.name);
    const devObj = {};
    names.forEach(name => devObj[name] = true);
    return (
      <FormControl variant="standard" className={classes.fullWidth} component="fieldset">
        <FormLabel className={classes.MuiInputLabel} data-shrink="true">Device Types</FormLabel>
        <FormGroup row className={classes.spread}>
          <FormControlLabel
            control={this.getCheckbox(devObj.Desktop, 'Desktop')}
            disabled={disabled}
            label="Desktop"
          />
          <FormControlLabel
            control={this.getCheckbox(devObj.Tablet, 'Tablet')}
            disabled={disabled}
            label="Tablet"
          />
          <FormControlLabel
            control={this.getCheckbox(devObj.Mobile, 'Mobile')}
            disabled={disabled}
            label="Mobile"
          />
          <FormControlLabel
            control={this.getCheckbox(devObj.None, 'None')}
            disabled={disabled}
            label="None"
          />
        </FormGroup>
      </FormControl>
    );
  }
}

DeviceTypes.defaultProps = {
  value: [],
  disabled: false
};

DeviceTypes.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default withStyles(styles)(DeviceTypes);
